import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { IIssue } from 'shared';

import { IssueService } from '../issue.service';
import { SharingService } from '../sharing.service';
import { BaseSocketEventHandler } from './base-socket-event-handler';

interface IssueArchivedSocketEvent {
    eventDtoType: 'IssueArchived';
    issue: IIssue;
}

@Injectable({ providedIn: 'root' })
export class IssueArchivedSocketEventHandler extends BaseSocketEventHandler<IssueArchivedSocketEvent> {
    private issueService = inject(IssueService);
    private sharingService = inject(SharingService);

    eventDtoType(): string {
        return 'IssueArchived';
    }

    handleEvent = async (event: IssueArchivedSocketEvent) => {
        // Remove issue locally
        this.issueService.localRemove(event.issue.id);
        // Get shared issue
        const sharedEntity = await firstValueFrom(this.sharingService.sharedEntity);
        // Update shared issue
        if (sharedEntity && sharedEntity.type === 'SHARED_ISSUE' && sharedEntity.issue.id === event.issue.id) {
            sharedEntity.issue.archived = true;
            this.sharingService.updateSharedEntity(sharedEntity);
        }
    };
}
